import React, { ReactNode } from 'react';
import { styled, useTheme } from '@mui/material/styles';

interface StickyRegionProps {
    children: ReactNode;
    top?: number;
    zIndex?: number;
    backgroundColor?: string;
}

const StyledStickyRegion = styled('div')<{ top: number; zIndex: number; backgroundColor: string }>(
    ({ top, zIndex, backgroundColor }) => ({
        position: 'sticky',
        top: `${top}px`,
        zIndex,
        backgroundColor
    })
);

export const StickyRegion = (props: StickyRegionProps) => {
    const theme = useTheme();
    const { children, top = 60, zIndex = 10, backgroundColor = theme.palette.neutral.white } = props;
    return (
        <StyledStickyRegion top={top} zIndex={zIndex} backgroundColor={backgroundColor}>
            {children}
        </StyledStickyRegion>
    );
};
